/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  partnerAccessRequests: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return initialState;

    case actionTypes.PARTNER_ACCESS_REQUESTS_RECEIVED:
      return {
        ...state,
        partnerAccessRequests: action.partnerAccessRequests,
      };

    case actionTypes.PARTNER_ACCESS_REQUESTS_CREATED: {
      return {
        ...state,
        partnerAccessRequests: [
          ...state.partnerAccessRequests,
          action.data.request,
        ],
      };
    }

    case actionTypes.PARTNER_ACCESS_REQUESTS_REMOVE:
      return {
        ...state,
        partnerAccessRequests: state.partnerAccessRequests.filter(
          request => request.id !== action.requestId,
        ),
      };

    default:
      return state;
  }
};
